import axios from 'axios'
import listasPrecioService from '@/services/listasPrecioService'

const state = {
  listasPrecio: []
}

const getters = {
  listasPrecio: state => state.listasPrecio
}

const actions = {
  async getListasPrecios({ commit }) {
    try {
      const listas = await listasPrecioService.obtenerListasPrecio()
      commit('SET_LISTAS_PRECIO', listas)
    } catch (error) {
      console.error('Error al obtener listas de precio:', error)
    }
  },getListasPrecioPorClienteVendedor({ commit }, { id_cliente, id_vendedor }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${process.env.VUE_APP_BASE_URL}productos/listas-precios/vendedor-cliente-publicas`, {
          params: {
            id_cliente,
            id_vendedor
          }
        })
        .then((response) => {
          commit('SET_LISTAS_PRECIO', response.data.data)
          resolve(response.data)
        })
        .catch((error) => {
          console.error('Error al obtener listas de precio por cliente y vendedor:', error)
          reject(error)
        })
    })
  }
}

const mutations = {
  SET_LISTAS_PRECIO(state, listas) {
    state.listasPrecio = listas
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
